import React, { useState } from 'react';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { brevoSubscription } from '../../util/api';

import SubscriptionForm from './SubscriptionForm';

import css from './SectionSubscription.module.css';

const SectionSubscriptionComponent = () => {

  const [submitStatus, setSubmitStatus] = useState('request');

  const onHandleSubmit = (values) => {

    return brevoSubscription(values)
      .then(res => {
        setSubmitStatus('success');
      })
      .catch((error) => {
        console.error('Error submitting:', error);
        setSubmitStatus('error');
      });
  };

  return (
    <div className={css.root}>
      {submitStatus === 'request' && (
        <SubscriptionForm
          onSubmit={onHandleSubmit}
          submitStatus={submitStatus}
        />
      )}

      {submitStatus === 'success' && (
        <p className={css.success}>
          <FormattedMessage id="SectionSubscription.success" />
        </p>
      )}

      {submitStatus === 'error' && (
        <p className={css.error}>
          <FormattedMessage id="SectionSubscription.error" />
        </p>
      )}
    </div>
  );
};

const SectionSubscription = compose(injectIntl)(SectionSubscriptionComponent);
SectionSubscription.displayName = 'SectionSubscription';

export default SectionSubscription;
